// Modals.jsx

import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  CkTextEditor,
  Divider,
  FormFieldSet,
  Modal,
  showToast,
  Backdrop,
  LogoLoader
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import { addEmailPost } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { getApplicantsFromInternalDB } from "../../../../../redux/slices/internalDbES/internalDbESApi";
import { getMailMergeAccessData } from "../../../../../redux/slices/setting/settingApi";
import { addTemplate, fetchEmailCounts } from "../../../../../redux/slices/compaigns/compaignsApi";
import { trackEvent } from "../../../../../utils/mixpanelService";


// 1) CREATE LIST MODAL
export const CreateListModal = ({
  showCreateListModal,
  SetShowCreateListModal,
}) => {
  return (
    <Modal
      title="Create List"
      isOpen={showCreateListModal}
      onClose={() => SetShowCreateListModal(false)}
      width="max-w-4xl"
      titleColor={"primary"}
      backBlur="0"
    >
      <div className="grid grid-cols-2 justify-center gap-4 py-5">
        <FormFieldSet
          type="text"
          title="List name"
          placeholder="Enter List Name"
        />


        <div className="flex items-center gap-2 w-full">
          <FormFieldSet
            title="Enter no. range (From To)"
            type="text"
            placeholder="From"
          />
          <FormFieldSet type="text" title=" " placeholder="To" />
        </div>

        <FormFieldSet type="text" title="Select the Job" placeholder="Enter" />
        <FormFieldSet
          type="multiSelect"
          title="Template"
          placeholder="select Template"
          showSearch
          showSelectAll
          shadow
        />
      </div>

      <div className="flex justify-end gap-5 mt-5">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={() => SetShowCreateListModal(false)}
        />
        <Button title={"Save"} />
      </div>
    </Modal>
  );
};

// 2) MAIL MERGE MODAL
export const MailMergeModal = ({
  mailMergeModalOpen,
  setMailMergeModalOpen,
  filteredMonsterMailMergeData,
  handleDelete,
  selectedData,
  source,
  searchQuery

}) => {
  const templates = useSelector(
    (state) => state.compaigns.emailTemplates.templates
  );
  const {
    totalApplicantsCount,
  } = useSelector((state) => state.internalDbES);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [jobData, setJobData] = useState("");
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [salutation, setSalutation] = useState("");
  const [emailInput, setEmailInput] = useState("")
  const [applicantData, setApplicantData] = useState([])
  const [emailsList, setEmailsList] = useState([])
  const [mailPage, setMailPage] = useState(1)
  const [mailLimit, setMailLimit] = useState(25)
  const [internalDBdata, setInternalDBdata] = useState([])
  const [idbTotalRecords, setidbTotalRecords] = useState(0)
  const [mailTotalData, setMailTotalData] = useState([])
  const editorRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    25,
    (_newPage, newLimit) => { }
  );
  const [loading, setLoading] = useState(false)
  const [emailBody, setEmailBody] = useState("");
  const [subject, setSubject] = useState(
    "Underground Utility Superintendent in US"
  );
  const [mailType, setMailType] = useState("");

  const [fromEmail, setFromEmail] = useState("");
  const [sendLimit, setSendLimit] = useState(0)


  const dispatch = useDispatch();

  let selectedBody = selectedTemplates?.body || null
  const savedRangeRef = useRef(null);
  const findEditorEl = () =>
    document.querySelector('.ck-text-editor [contenteditable="true"], .ck-editor-content, [contenteditable="true"], [contenteditable]');
  useEffect(() => {
    const onSelectionChange = () => {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;

      const range = sel.getRangeAt(0);
      // ensure selection is inside our editor element
      const editorEl = findEditorEl();
      if (!editorEl) return;

      // get actual container node
      let container = range.commonAncestorContainer;
      if (container.nodeType === Node.TEXT_NODE) container = container.parentNode;

      if (editorEl.contains(container)) {
        // clone and save
        try {
          savedRangeRef.current = range.cloneRange();
        } catch (e) {
          savedRangeRef.current = null;
        }
      }
      // else do not overwrite savedRangeRef — we want the last in-editor range
    };

    document.addEventListener("selectionchange", onSelectionChange);
    return () => document.removeEventListener("selectionchange", onSelectionChange);
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     getTemplatesStart({
  //       coll: "Template",
  //       lim: 5,
  //       pg: 1,
  //       //ret: "uiid addedBy usedCount addedOn modified",
  //       extret: "uiid firstName lastName email",
  //       ret: "title body uiid addedBy",
  //       sort: { addedOn: -1 },
  //     })
  //   );
  // }, [dispatch]);


  const fetchIDBApplicants = async () => {
    if (filteredMonsterMailMergeData?.length > 0) {
      if (!jobData || !selectedTemplates) {
        showToast("Please Fill the Details", "warning", 2000)
        return
      } else {
        setIsNextClicked(true)
      }

      const emails = filteredMonsterMailMergeData
        .map(item => item?.email?.primary?.email ?? item?.email?.primary ?? item?.email)
        .filter(Boolean);
      setEmailsList(emails)
    } else {
      const payload = {
        query: { ...searchQuery?.payload?.query },
        lim: Number(mailLimit) ?? 25,
        page: mailPage ?? 1,
        addedBy: user?.data?.uiid,
        source: source === 1 ? 1 : 6,
        notes: false
      };
      if (!jobData || !selectedTemplates) {
        showToast("Please Fill the Details", "warning", 2000)
        return
      }
      // } else {
      //   setIsNextClicked(true)
      // }

      try {
        setLoading(true)
        let res = await getApplicantsFromInternalDB({ payload: payload });
        const data = res?.data?.field?.data?.candidates
        const totalRecords = res?.data?.field?.data?.totalRecords ?? 0
        setidbTotalRecords(totalRecords)
        setInternalDBdata(data)
        const emails = data
          .map(item => item?.email?.primary?.email ?? item?.email?.primary)
          .filter(Boolean);
        setEmailsList(emails)
        setIsNextClicked(true)
        setLoading(false)
      } catch (err) {
        setLoading(false)
        console.error(err);
        setIsNextClicked(true)
        setLoading(false)
        showToast("Failed to fetch applicant details", "error");
      } finally {
        setLoading(false)
      }

    };
  }

  const fetchAllApplicants = async () => {
    if (source === 1 || source === "integratedIDB") {
      fetchIDBApplicants()
    } else {
      // const uiids = filteredMonsterMailMergeData.map(item => item?.uiid).filter(Boolean);
      if (!jobData || !selectedTemplates) {
        showToast("Please Fill the Details", "warning", 2000)
        return
      } else if (filteredMonsterMailMergeData?.length === 0) {
        showToast("Atleast One Candidate need to be selected", "warning", 2000)
        return
      }
      else {
        setIsNextClicked(true)
      }

      // try {
      //   let res = await getApplicants({
      //     fil: JSON.stringify({
      //       uiid: { type: "IN", value: uiids },
      //     }),
      //     coll: "Candidate",
      //     lim: uiids.length,
      //     extret: "uiid firstName",
      //     ret: "uiid email"
      //   });
      //   const data = res?.data?.data
      //   setApplicantData(data)
      const emails = filteredMonsterMailMergeData
        .map(item => item?.email?.primary?.email ?? item?.email?.primary ?? item?.email)
        .filter(Boolean);
      setEmailsList(emails)
      // } catch (err) {
      //   console.error(err);
      //   showToast("Failed to fetch applicant details", "error");
      // }
    }
  };
// const senderPool = [
//   "recruitment@mg.tektreerecruiters.com",
//   "recruiting@mg.tektreerecruiters.com",
//   "talent@mg.tektreerecruiters.com",
//   "talentacquisition@mg.tektreerecruiters.com",
//   "careers@mg.tektreerecruiters.com",
//   "hiring@mg.tektreerecruiters.com",
//   "talentteam@mg.tektreerecruiters.com",
//   "talentpartner@mg.tektreerecruiters.com",
//   "recruiter@mg.tektreerecruiters.com",
//   "staffing@mg.tektreerecruiters.com",
//   "staffingteam@mg.tektreerecruiters.com",
//   "placements@mg.tektreerecruiters.com",
//   "placementteam@mg.tektreerecruiters.com",
//   "jobs@mg.tektreerecruiters.com",
//   "jobdesk@mg.tektreerecruiters.com",
//   "jobalerts@mg.tektreerecruiters.com",
//   "consulting@mg.tektreerecruiters.com",
//   "consultants@mg.tektreerecruiters.com",
//   "recruitmentteam@mg.tektreerecruiters.com",
//   "talentdesk@mg.tektreerecruiters.com",
//   "careerdesk@mg.tektreerecruiters.com",
//   "hiringteam@mg.tektreerecruiters.com",
//   "sourcer@mg.tektreerecruiters.com",
//   "sourcing@mg.tektreerecruiters.com",
//   "techrecruitment@mg.tektreerecruiters.com",
//   "talentconnect@mg.tektreerecruiters.com"
// ];
const senderPools = {
  "mg.tektreerecruiters.com": [
    "recruitment@mg.tektreerecruiters.com",
    "recruiting@mg.tektreerecruiters.com",
    "talent@mg.tektreerecruiters.com",
    "talentacquisition@mg.tektreerecruiters.com",
    "careers@mg.tektreerecruiters.com",
    "hiring@mg.tektreerecruiters.com",
    "talentteam@mg.tektreerecruiters.com",
    "talentpartner@mg.tektreerecruiters.com",
    "recruiter@mg.tektreerecruiters.com",
    "staffing@mg.tektreerecruiters.com",
    "staffingteam@mg.tektreerecruiters.com",
    "placements@mg.tektreerecruiters.com",
    "placementteam@mg.tektreerecruiters.com",
    "jobs@mg.tektreerecruiters.com",
    "jobdesk@mg.tektreerecruiters.com",
    "jobalerts@mg.tektreerecruiters.com",
    "consulting@mg.tektreerecruiters.com",
    "consultants@mg.tektreerecruiters.com",
    "recruitmentteam@mg.tektreerecruiters.com",
    "talentdesk@mg.tektreerecruiters.com",
    "careerdesk@mg.tektreerecruiters.com",
    "hiringteam@mg.tektreerecruiters.com",
    "sourcer@mg.tektreerecruiters.com",
    "sourcing@mg.tektreerecruiters.com",
    "techrecruitment@mg.tektreerecruiters.com",
    "talentconnect@mg.tektreerecruiters.com"
  ],

  "mg.tektreeglobaltalent.com": [
    "recruitment@mg.tektreeglobaltalent.com",
    "recruiting@mg.tektreeglobaltalent.com",
    "talent@mg.tektreeglobaltalent.com",
    "talentacquisition@mg.tektreeglobaltalent.com",
    "careers@mg.tektreeglobaltalent.com",
    "hiring@mg.tektreeglobaltalent.com",
    "talentteam@mg.tektreeglobaltalent.com",
    "talentpartner@mg.tektreeglobaltalent.com",
    "recruiter@mg.tektreeglobaltalent.com",
    "staffing@mg.tektreeglobaltalent.com",
    "staffingteam@mg.tektreeglobaltalent.com",
    "placements@mg.tektreeglobaltalent.com",
    "placementteam@mg.tektreeglobaltalent.com",
    "jobs@mg.tektreeglobaltalent.com",
    "jobdesk@mg.tektreeglobaltalent.com",
    "jobalerts@mg.tektreeglobaltalent.com",
    "consulting@mg.tektreeglobaltalent.com",
    "consultants@mg.tektreeglobaltalent.com",
    "recruitmentteam@mg.tektreeglobaltalent.com",
    "talentdesk@mg.tektreeglobaltalent.com",
    "careerdesk@mg.tektreeglobaltalent.com",
    "hiringteam@mg.tektreeglobaltalent.com",
    "sourcer@mg.tektreeglobaltalent.com",
    "sourcing@mg.tektreeglobaltalent.com",
    "techrecruitment@mg.tektreeglobaltalent.com",
    "talentconnect@mg.tektreeglobaltalent.com"
  ]
};
const selectedFromEmail = fromEmail?.label ?? fromEmail ?? "";
const domain = selectedFromEmail.includes("@")
  ? selectedFromEmail.split("@")[1].toLowerCase()
  : null;
const domainPool = senderPools[domain] || senderPools["mg.tektreerecruiters.com"]; 
const handleSendEmail = async () => {
    if (!mailType || !fromEmail) {
      showToast("Please Fill the fields", "error", 2000)
      return
    }
    const limitCount = Number(mailTotalData?.limit ?? 0)
    if (!limitCount) {
      showToast("Daily limit not assigned", "error", 2000)
      return
    }
    const count = limitCount - sendLimit
    if (count <= 0) return
    setLoading(true)
    try {
      let resp
      const normalize = (t = "") =>
        t
          .toLowerCase()               // make comparison case-insensitive
          .replace(/\r\n/g, "\n")      // normalize Windows line breaks to Unix style
          .trim();                     // remove leading and trailing spaces

      const htmlToPlainText = (html = "") => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        return temp.innerText || temp.textContent || "";
      };
      const convertedText1 = htmlToPlainText(selectedTemplates?.body)
      const convertedText2 = htmlToPlainText(emailBody)
      const isSameTemplate = normalize(convertedText1) === normalize(convertedText2);
      if (emailBody && isSameTemplate === false) {
        const payload = {
          addedBy: user.data?.uiid,
          title: `${user?.data?.firstName} ${user?.data?.lastName} ${new Date().toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}`,
          subject: subject || selectedTemplates?.subject,
          body: emailBody || selectedTemplates?.body,
          assignedTo: user.data?.uiid,
        };
        resp = await addTemplate({ coll: "Template", payload });
      }
      let applicantionData
      if (source === 1 || source === "integratedIDB") {
        if (filteredMonsterMailMergeData.length === 0) {
          applicantionData = internalDBdata
        } else {
          applicantionData = filteredMonsterMailMergeData
        }
      } else {
        applicantionData = filteredMonsterMailMergeData
      }

      const filteredUniqueEmailData = (() => {
        const seenEmails = new Set();

        return (applicantionData ?? []).filter((item) => {
          const email =
            (item?.email?.primary?.email ??
              item?.email?.primary ??
              item?.email ??
              "").toLowerCase();

          if (!email) return false;          
          if (seenEmails.has(email)) return false; 

          seenEmails.add(email);
          return true; 
        });
      })();

      // const internal = (filteredUniqueEmailData ?? [])?.map(item => ({
      //   candidateId: item?.uiid ?? item?.applicantId ?? null,
      //   email: {
      //     primary: {
      //       email: item?.email?.primary?.email ?? item?.email?.primary ?? item?.email ?? "",
      //       status: item?.email?.primary?.status ?? "",
      //       verifiedDate: item?.email?.primary?.verifiedDate ?? ""
      //     }
      //   },
      //   addedBy: user?.data?.uiid,
      //   from: fromEmail?.label ?? fromEmail,
      //   integrationAccessId: fromEmail?.accessUiid,
      //   jobPostId: jobData?.uiid,
      //   templateId: resp?.data?.uiid || selectedTemplates?.value || 1,
      //   source: mailType,
      //   typeOfEmail: 1,
      //   status: 2,
      //   error: ""
      // }));
      const internal = (filteredUniqueEmailData ?? [])?.map((item, index) => {
  const sender = domainPool [index % domainPool.length];
  return {
    candidateId: item?.uiid ?? item?.applicantId ?? null,
    email: {
      primary: {
        email: item?.email?.primary?.email 
              ?? item?.email?.primary 
              ?? item?.email 
              ?? "",
        status: item?.email?.primary?.status ?? "",
        verifiedDate: item?.email?.primary?.verifiedDate ?? ""
      }
    },
    addedBy: user?.data?.uiid,
    // from: sender, 
     from: mailType===3 ? sender : fromEmail?.label ?? fromEmail,
    integrationAccessId: fromEmail?.accessUiid,
    jobPostId: jobData?.uiid,
    templateId: resp?.data?.uiid || selectedTemplates?.value || 1,
    source: mailType,
    typeOfEmail: 1,
    error: ""
  };
});
      const trimmedInternal = internal.slice(0, count);

      const extractEmails = (text) => {
        return text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g) || [];
      };

      const emailsList = extractEmails(emailInput);

      // const manual = emailsList?.map(email => ({
      //   candidateId: null,
      //   email: email,
      //   addedBy: user?.data?.uiid,
      //   // from: fromEmail?.label ?? fromEmail,
      //   templateId: resp?.data?.uiid || selectedTemplates?.value,
      //   source: mailType,
      //   typeOfEmail: 1,
      //   integrationAccessId: fromEmail?.accessUiid,
      //   jobPostId: jobData?.uiid
      // }));
      const manual = emailsList?.map((email, index) => {
        const sender = domainPool [index % domainPool.length];
        return {
    candidateId: null,
    email: email,
    addedBy: user?.data?.uiid,
    from: mailType===3 ? sender : fromEmail?.label ?? fromEmail,
    templateId: resp?.data?.uiid || selectedTemplates?.value,
    source: mailType,
    typeOfEmail: 1,
    integrationAccessId: fromEmail?.accessUiid,
    jobPostId: jobData?.uiid
  };
});
      const res = await addEmailPost({
        coll: "CandidateEmailLog",
        payload: {
          internal: [...trimmedInternal],
          manual: [...manual],
          integrationAccessId: fromEmail?.accessUiid,
          addedBy: user?.data?.uiid,
        },
      });
      if (res?.data) {
        trackEvent({eventName:"MailMerge_Sent_Batch",props:{internal:trimmedInternal?.length,manual:manual?.length,source:mailType}})
        showToast("Mail Merge Successfull", "success", 2000)
        setMailMergeModalOpen(false)
        setIsNextClicked(false)
        setMailType("")
        setFromEmail("")
        setEmailInput("")
        setSelectedTemplates("")
        setSubject("")
        setJobData("")
        setMailTotalData([])
        setSendLimit(0)
        showToast(`Your daily email sending limit: ${count <= 0 ? 0 : count - emailsList.length} remaining`, "warning", 2000)
      }
    } catch (error) {
      showToast("Mail Merge Unuccessfull", "error", 2000)
      setLoading(false)
      handleCloseModal()
    } finally {
      setLoading(false)
     // setMailTotalData([])
      //setSendLimit(0)
      handleCloseModal()
    }
  };

  const InfoRow = ({ label, value }) => (
    <div className="mt-1">
      <div className="text-xs text-primary-500">{label}</div>
      <div className="text-xs font-medium text-black">{value || "--"}</div>
    </div>
  );

  const InfoGridRow = ({ left, right }) => (
    <div className="flex justify-between mt-1">
      <InfoRow label={left.label} value={left.value} />
      <div className="text-right">
        <InfoRow label={right.label} value={right.value} />
      </div>
    </div>
  );

  /** 2) Safe insert helper: tries CKEditor API first, otherwise DOM fallback **/
  const insertAtCursor = (valueHtmlOrText, { asHtml = false } = {}) => {
    // 1) Try CKEditor API if you have a proper instance
    const editor = editorRef.current;
    if (editor && editor.model && editor.data && editor.editing) {
      try {
        if (!asHtml) {
          // escape text
          const escapeHtml = (s) =>
            s.replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#039;");
          valueHtmlOrText = escapeHtml(valueHtmlOrText);
        }
        editor.model.change((writer) => {
          const viewFragment = editor.data.processor.toView(valueHtmlOrText);
          const modelFragment = editor.data.toModel(viewFragment);
          editor.model.insertContent(modelFragment, editor.model.document.selection);
        });
        editor.editing.view.focus();
        return true;
      } catch (err) {
        console.warn("CKEditor insert failed, falling back to DOM insert:", err);
      }
    }

    // 2) DOM fallback (restore saved range if available)
    const editorEl = findEditorEl();
    if (!editorEl) {
      console.warn("No editor element found for DOM insert.");
      return false;
    }

    const sel = window.getSelection();
    let rangeToUse = null;

    // prefer savedRangeRef (cloned while selection was inside editor)
    if (savedRangeRef.current) {
      try {
        // restore selection from savedRangeRef
        sel.removeAllRanges();
        sel.addRange(savedRangeRef.current);
        rangeToUse = sel.getRangeAt(0).cloneRange();
      } catch (e) {
        // if failing, will create a range at end
        rangeToUse = null;
      }
    }

    // if no saved range or restoration failed, check current selection inside editor
    if (!rangeToUse) {
      if (sel && sel.rangeCount > 0) {
        const r = sel.getRangeAt(0);
        const container = r.commonAncestorContainer.nodeType === 3 ? r.commonAncestorContainer.parentNode : r.commonAncestorContainer;
        if (editorEl.contains(container)) {
          rangeToUse = r.cloneRange();
        }
      }
    }

    // if still no usable range, create range at end of editor
    if (!rangeToUse) {
      rangeToUse = document.createRange();
      rangeToUse.selectNodeContents(editorEl);
      rangeToUse.collapse(false); // caret at end
    } else {
      // delete contents of selection (we will replace with inserted content)
      rangeToUse.deleteContents();
    }

    // construct fragment
    let frag;
    if (asHtml) {
      const tmp = document.createElement("div");
      tmp.innerHTML = valueHtmlOrText;
      frag = document.createDocumentFragment();
      while (tmp.firstChild) frag.appendChild(tmp.firstChild);
    } else {
      frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(valueHtmlOrText));
    }

    // insert nodes
    rangeToUse.insertNode(frag);

    // move caret after the inserted nodes
    const newRange = document.createRange();
    // try to place after last inserted node
    try {
      // if lastChild of fragment exists and is in DOM, use it
      let last = null;
      // find last inserted node: it should be the node just before rangeToUse.startContainer.nextSibling or we can traverse
      // simplest approach: collapse to end of selection by selecting contents of editor and collapsing to end
      newRange.selectNodeContents(editorEl);
      newRange.collapse(false);
    } catch (err) {
      newRange.selectNodeContents(editorEl);
      newRange.collapse(false);
    }

    sel.removeAllRanges();
    sel.addRange(newRange);
    if (typeof editorEl.focus === "function") editorEl.focus();

    // trigger input so child detects change
    editorEl.dispatchEvent(new Event("input", { bubbles: true }));

    // optionally clear savedRangeRef because we've consumed it:
    savedRangeRef.current = null;

    return true;
  };


  /** 3) Salutation handler: uses insertAtCursor and falls back to updating state */
  const handleSalutationChange = (incoming) => {
    const value = incoming?.target?.value ?? incoming;
    setSalutation(value);

    // prefer plain text insertion
    const ok = insertAtCursor(value, { asHtml: false });

    if (!ok) {
      // fallback append to state
      setEmailBody((prev) => prev + " " + value);
    }
  };

  // placeholders / options
  const options = [
    { label: "${firstName}", value: "${firstName}" },
    { label: "${lastName}", value: "${lastName}" },
    //{ label: "${jobTitle}", value: "${jobTitle}" },
    //{ label: "${jobLocation}", value: "${jobLocation}" },
  ];



  const integrationMailMerge = async () => {
    try {
      let accessRes = await getMailMergeAccessData({
        coll: "IntegrationAccess",
        fil: {
          uiid: {
            type: "NONE", value: fromEmail?.accessUiid ?? null
          },
        },
        ref: "Integration",

      });
      let data = accessRes?.data?.data?.accessConfig
      setMailTotalData(data)
      //console.log(mailTotalData)
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    if (fromEmail?.accessUiid) {
      integrationMailMerge();
    }
  }, [fromEmail]);

  const limits = {
    totalDailyLimit: 0,
    teamLimit: 0,
    remaining: 0,
    perShot: 0,
  };
  useEffect(() => {
    setEmailBody(selectedTemplates?.body || "");
  }, [selectedTemplates?.body]);



  const fetchEmailCountsData = async () => {
    const today = new Date();
    const from = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
    const to = new Date(new Date().setHours(23, 59, 59, 999)).toISOString();

    const params = {
      coll: "CandidateEmailLog",
      fil: {
        addedOn: { type: "DATE_RANGE", "value": { from: from, to: to } },
        integrationAccessId: { type: "NONE", value: fromEmail?.accessUiid }
      },
    }
    const call = await fetchEmailCounts(params)
    const limit = call?.data?.data
    setSendLimit(limit)
  }

  useEffect(() => {
    if (fromEmail?.accessUiid) {
      fetchEmailCountsData()
    }
  }, [fromEmail])
const handleCloseModal=async()=>{
   setMailMergeModalOpen(false),
   setIsNextClicked(false),
   setSelectedTemplates(""),
   setSubject("")
    setJobData(""),
    setMailType(""),
     setFromEmail(""),
    setEmailInput(""),
    setPage(1),
    setMailLimit(25),
    setidbTotalRecords(0)
}
  return (
    <>
      <Modal
        title="Mail Merge"
        isOpen={mailMergeModalOpen}
        onClose={() => {
         handleCloseModal()
        }}
        width={isNextClicked ? "max-w-7xl" : "max-w-4xl"}
        titleColor="primary"
        backBlur="0"
      >
        {!isNextClicked ? (
          // <div className="flex gap-4">
          <div className="flex flex-col lg:flex-row gap-4">
            {/* LEFT SIDE FORM */}
            <div className="flex flex-col gap-4 w-full">
              {/* <div className="text-xs text-info-500">
              No. of Applicants: {filteredMonsterMailMergeData?.length ?? 0}
            </div> */}

              <FormFieldSet
                type="companiesSearch"
                // type="text"
                title="Select The Job"
                placeholder="Select The Job"
                value={jobData}
                showSearch
                onChange={(value) => setJobData(value)}
              />
              {filteredMonsterMailMergeData?.length === 0 && (source === 1 || source == "integratedIDB") &&
                <div className="flex items-center gap-2">
                  <FormFieldSet
                    type="text"
                    title="Enter no. range (From To)"
                    value={mailPage}
                    onChange={(value) => {
                      const numericValue = Number(value);
                      if (!/^\d+$/.test(numericValue)) return;
                      if (numericValue <= 0) {
                        setMailPage();
                        showToast("Value should be at least 1", "warning", 2000);
                      } else if (numericValue > totalApplicantsCount) {
                        setMailPage(totalApplicantsCount);
                        showToast(`Not more than Applicant Count ${totalApplicantsCount}`, "error", 2000);
                      } else {
                        setMailPage(numericValue);
                      }

                    }}
                    placeholder="From"
                  />
                  <FormFieldSet
                    type="text"
                    title=" "
                    value={mailLimit}
                    onChange={(value) => {
                      const numericValue = Number(value);
                      if (numericValue <= 1000) {
                        setMailLimit(value);
                      } else {
                        setMailLimit(25);
                        showToast("1000 is Max range", "warning", 1000)
                      }
                    }}
                    placeholder="To"
                  />
                </div>}

              <FormFieldSet
                type="templates"
                title="Choose Template"
                placeholder="Choose Template"
                showSearch
                showSelectAll
                // options={templateOptions}
                value={selectedTemplates}
                onChange={(value) => {
                  //console.log(value)
                  setSelectedTemplates(value);
                  setSubject(value?.subject||"")
                }}
                shadow
                filters={{ userId: user?.data?.role?.type === 1 ? "" : user?.data?.uiid }}
              />

              <div className="flex justify-end gap-4 pt-4">
                <Button
                  title="Cancel"
                  variant="outlined"
                  onClick={() => { setMailMergeModalOpen(false); setSelectedTemplates(""); setJobData(""); setMailType(""); setFromEmail(""); setEmailInput(""), setMailLimit(25),setMailPage(1) }}
                />
                <Button title="Next" onClick={() => { fetchAllApplicants() }} />
              </div>
            </div>
            {(selectedData?.length || filteredMonsterMailMergeData?.length > 0) && (
              <>
                <Divider orientation="vertical" />

                {/* RIGHT SIDE SELECTED PROFILES */}
                <div className="flex flex-col gap-3 w-full max-h-[30vh] overflow-y-auto pr-2">
                  {[
                    ...new Map(
                      filteredMonsterMailMergeData?.map(cand => {
                        const id = cand?.applicantId ?? cand?.uiid;
                        return [id, cand]; // key = unique id
                      })
                    ).values()
                  ].map((cand) => {
                    const id = cand?.applicantId ?? cand?.uiid;
                    return (
                      <div
                        key={id}
                        className="border border-gray-200 rounded-md shadow-sm p-4 bg-gray-50"
                      >
                        <div className="flex justify-between items-start">
                          <div>
                            <div className="text-xs text-gray-400 mb-1">
                              Profile used
                            </div>
                            <div className="font-semibold text-sm text-black">
                              {cand.name ?? `${cand?.firstName ?? ""} ${cand?.lastName ?? ""}`}
                            </div>
                          </div>
                          <Button
                            type="icon"
                            icon="delete"
                            variant="text"
                            size="sm"
                            onClick={() => handleDelete(id)}
                          />
                        </div>
                        <Divider className="my-2" />
                        <InfoRow label="Email" value={cand.email?.primary?.email ?? cand.email?.primary ?? cand.email ?? "-"} />
                        <InfoGridRow
                          left={{ label: "Job Title", value: cand.jobTitle }}
                          right={{ label: "Experience", value: cand.experience }}
                        />
                        <InfoGridRow
                          left={{
                            label: "Pay rate",
                            value: cand.payrate || "N/A",
                          }}
                          right={{
                            label: "Notice Period",
                            value: cand.noticePeriod,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        ) : (
          <>
            {/* <div className="flex gap-6"> */}
            <div className="flex flex-col xl:flex-row gap-6">
              {/* LEFT SECTION */}
              <div className="flex-[2]">
                <div className="flex items-center gap-2 mt-2 mb-4">
                  <div className="w-1 h-9 bg-info-500"></div>
                  <h3 className="text-lg font-semibold">Send Mail</h3>
                </div>

                {/* <div className="flex gap-3 mb-4"> */}
                <div className="flex flex-col md:flex-row gap-3 mb-4">
                  <div className="flex-1">
                    <FormFieldSet
                      type="select"
                      title="Mail Type"
                      value={mailType}
                      options={[
                        { label: "Gmail", value: 1 },
                        { label: "Outlook", value: 2 },
                        { label: "Mailgun", value: 3 },
                        { label: "AWS-SES", value: 4 },
                        { label: "Sendgrid", value: 6 },
                      ]}
                      placeholder="Select"
                      onChange={(value) => { setMailType(value); setFromEmail("") }}

                      shadow={true}
                      required
                    />
                  </div>

                  <div className="flex-1">
                    <FormFieldSet
                      type="emailSourceAccounts"
                      title="From"
                      value={fromEmail}
                      placeholder="From mail id"
                      onChange={(value) => setFromEmail(value)}
                      filters={{ category: 11, type: mailType, userId: user?.data?.role?.type === 1 ? "" : user?.data?.uiid }}
                      required
                    />
                  </div>

                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      title="Mail Subject"
                      value={subject }

                      placeholder="Enter Subject"
                      onChange={(value) => setSubject(value)}
                      required
                    />
                  </div>
                </div>

                <div className="text-sm mb-3">
                  Number of Recipients : {(idbTotalRecords > 0
                    ? idbTotalRecords
                    : filteredMonsterMailMergeData
                      ? new Set(filteredMonsterMailMergeData.map(item => {
                        // Use applicantId if available, otherwise fallback to uiid
                        return item.applicantId || item.uiid;
                      })).size
                      : 0)}</div>

                <div className="text-[13px] text-gray-600 mb-4">
                  <span>List of email ids:</span>
                  <br />
                  {[...new Set(emailsList)].slice(0, 2).join(", ")}
                  , .....

                </div>

                <FormFieldSet
                  type="textArea"
                  title="Include Test Emails here :-0(Note: Please Separate email addresses with spaces or commas)"
                  value={emailInput}
                  placeholder=""
                  onChange={(value) => setEmailInput(value)}
                  rows={4}
                />

                {/* <div className="mt-4"> */}
                <div className="mt-4 w-full max-w-full xl:max-w-3xl">
                  <CkTextEditor
                    value={emailBody}
                    onChange={(...args) => {
                      // console.log("CkTextEditor onChange args:", args);
                      const data = args[0];
                      const possibleEditor = args[1];
                      setEmailBody(data);
                      if (possibleEditor) {
                        editorRef.current = possibleEditor;
                        //console.log("Stored CKEditor instance in editorRef");
                      } else {
                        // don't overwrite if we already had an editorRef with something useful
                        //console.log("No editor instance passed in onChange");
                      }
                    }}
                    //readOnly={true}
                    placeholder="Write your email here..."
                  />
                </div>
                <div className="flex justify-end gap-4 pt-4">
                  <Button
                    title="Cancel"
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal()
                    }}
                  />
                  <Button
                    title="Send" onClick={() => {
                      handleSendEmail();
                    }}
                  />
                  <Backdrop isOpen={loading}>
                    <LogoLoader />
                  </Backdrop>
                </div>
              </div>

              {/* RIGHT SECTION */}
              <div className="flex-1 xl:border-l xl:pl-6 pt-6 lg:pt-0">
                <div className="flex items-center gap-2 mt-2 mb-4">
                  <div className="w-1 h-9 bg-info-500"></div>
                  <h3 className="text-lg font-semibold">Customize Mail Body</h3>
                </div>
                <FormFieldSet
                  type="select"
                  title="Salutation"
                  options={options}
                  value={salutation}
                  onChange={(value) => handleSalutationChange(value)}
                  required
                />

                <div className="text-danger-300 text-sm mt-6 space-y-3">
                  <div className="text-info-400">
                    Your total daily email limit in mail merge. <br />
                    <b className="text-black">{mailTotalData?.limit ?? limits.totalDailyLimit}</b>
                  </div>

                  <div>
                    Total daily email limit for the team in mail merge. <br />
                    <b className="text-black">{limits.teamLimit}</b>
                  </div>

                  <div>
                    Your remaining daily email limit in mail merge. <br />
                    <b className="text-black">{(mailTotalData?.limit ?? 0) - sendLimit > 0 ? (mailTotalData?.limit ?? 0) - sendLimit : 0}</b>
                  </div>

                  <div>
                    Your limit perShotPerRecruiter in mail merge. <br />
                    <b className="text-black">{1000}</b>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Modal>
      <Backdrop isOpen={loading} zIndex={53}>
        <LogoLoader />
      </Backdrop>
    </>

  );
};

// 3) MIGRATE PROFILES MODAL
export const MigrateProfilesModal = ({
  migrateProfilesModalOpen,
  setMigrateProfilesModalOpen,
  filteredMonsterMailMergeData,
  handleonClick,
  noResCandidateslength
}) => {
  return (
    <Modal
      showCloseButton={false}
      isOpen={migrateProfilesModalOpen}
      onClose={() => setMigrateProfilesModalOpen(false)}
      width="max-w-xl"
      titleColor={"primary"}
    >
      <div className="flex flex-col items-center gap-2">
        <p>
          The system will migrate the {(noResCandidateslength > 10) ? 10 : noResCandidateslength} new
          profiles automatically.
        </p>
        <p>Please click yes to proceed.</p>
        <div className="flex justify-center gap-5 mt-5">
          <Button
            title={"Cancel"}
            variant="outlined"
            onClick={() => setMigrateProfilesModalOpen(false)}
          />
          <Button disabled={noResCandidateslength == 0 ? true : false} title={"Yes"} onClick={handleonClick} />
        </div>
      </div>
    </Modal>
  );
};
